<template>
  <div class="wrap">
      <wedHd></wedHd>
        <div class="head_img">
            <img src="@/assets/images/wap/SMSwap.png" alt="">
        </div>
        <div class="ct_box">
            <div class="advantage_box">
                <div class="titleBox">产品优势</div>
                <ul class="content">
                    <li>
                        <div class="lis_box">
                            <img src="@/assets/images/wap/SMSadvantage1.png" alt="">
                            <p class="til">全网覆盖</p>
                            <p class="text">移动、联通、电信三网，全号段覆盖</p>
                        </div>
                        <div class="lis_box">
                            <img src="@/assets/images/wap/SMSadvantage2.png" alt="">
                            <p class="til">高达到率99.9%</p>
                            <p class="text">多通道智能切换，保障高到达率</p>
                        </div>
                    </li>
                    <li>
                        <div class="lis_box">
                            <img src="@/assets/images/wap/SMSadvantage3.png" alt="">
                            <p class="til">接入快速</p>
                            <p class="text">文档完善快速接入，签名模板快速完成审核</p>
                        </div>
                        <div class="lis_box">
                            <img src="@/assets/images/wap/SMSadvantage4.png" alt="">
                            <p class="til">主备通道</p>
                            <p class="text">完备的监控和资源配置系统，主备通道规避风险</p>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="scenario_box">
                <div class="titleBox">应用场景</div>
                <div class="scenario_ct">
                    <div class="cil_til">1、短信验证码</div>
                    <p class="cli_text">提供三网合一的高质量专用通道，5S秒内必达，多级安全保护；适用于注册登录验证，找回密码，支付认证等场景</p>
                    <div class="img_box">
                        <img src="@/assets/images/wap/SMSscenario1.png" alt="">
                    </div>
                </div>
                <div class="scenario_ct">
                    <div class="cil_til">2、系统通知推送</div>
                    <p class="cli_text">提供通知类文字短信服务，三网合一的高质量专用通道，多级级安全保护；签名、模板配置简单，审核快速。适用于服务通知、物流通知、系统通知等应用场景。</p>
                    <div class="img_box">
                        <img src="@/assets/images/wap/SMSscenario2.png" alt="">
                    </div>
                </div>
                <div class="scenario_ct">
                    <div class="cil_til">3、业务营销推广</div>
                    <p class="cli_text">提供运营类文字短信服务，内置内容模板，三网合一的高质量专用通道，多级安全保护；适用于会员服务、客户关怀、新品发布等使用场景。</p>
                    <div class="img_box">
                        <img src="@/assets/images/wap/SMSscenario3.png" alt="">
                    </div>
                </div>
            </div>
        </div>
      <wedFt></wedFt>
  </div>
</template>

<script>
import wedHd from '@/components/wepHearder.vue'
import wedFt from '@/components/wefot.vue'
export default {
    components:{
        wedHd,
        wedFt,
    },

}
</script>

<style scoped>
.wrap{
    background: #f4f5f6;
}
.head_img img{
    width: 100%;
    object-fit: cover;
}
.titleBox{
    width: 100%;
    height: 58px;
    line-height: 58px;
    color: #1C2A39;
    font-size: 20px;
    background: url(../../assets/images/wap/title.png) no-repeat left top;
    background-size:29px;
    padding-left: 15px;
    /* border-bottom: 1px solid #EDEEF0; */
}
.advantage_box{
    background-color: #fff;
}
.content li{
    display: flex;
}
.content .lis_box{
    flex: 12;
    text-align: center;
    padding: 0.4rem 0.6rem;
}
.content .lis_box img{
    width: 35%;
}
.content .lis_box .til{
    font-size: 0.35rem;
    margin-bottom: 0.19rem;
}
.content .lis_box .text{
    font-size: 0.29rem;
    color: #666;
}
.scenario_box{
    background-color: #fff;
    margin-top: 10px;
}
.scenario_box .scenario_ct{
    padding:0 0.55rem;
    margin-top: 0.96rem;
}
.scenario_box .scenario_ct .cil_til{
    font-size: 0.4rem;
    font-weight: bold;
    
}
.scenario_box .scenario_ct .cli_text{
    color: #4D5865;
    font-size: 0.37rem;
    margin-bottom: 0.53rem;
    margin-top: 0.21rem;
    line-height: 1.5;
}
.scenario_box .scenario_ct .img_box{
    text-align: center;
}
.scenario_box .scenario_ct .img_box img{
    width: 90%;
    /* margin-bottom: -2px; */
    vertical-align: bottom;
}


</style>


// WEBPACK FOOTER //
// src/pages/wapSMSPro/index.vue